import company from './company'
import fundraising from './fundraising'
import membership from './membership'
import openEnterprise from './open-enterprise'
import reputation from './reputation'
import dandelion from './dandelion'

// see the corresponding prop type, OrgTemplateType, in prop-types.js.

export default [
  company,
  membership,
  reputation,
  openEnterprise,
  dandelion,
  fundraising,
]
